import { createTheme } from "@mui/material";
import { red } from "@mui/material/colors";
import { ThemeProperties } from "./ThemeProperties";

const theme = createTheme({
  palette: {
    // mode: "dark",
    primary: {
      main: ThemeProperties.purple,
    },
    error: {
      main: ThemeProperties.red_400,
    },
    customRibRed: {
      main: red[400],
      superDark: red[800],
      superLight: red[100],
    },
  },
  typography: {
    tableRow: {
      fontFamily: ThemeProperties.primaryFont,
      fontSize: "13.5px",
      "@media (max-width:1350px)": {
        fontSize: "12.5px",
      },
      color: ThemeProperties.black,
    },
    tableHeadBold: {
      fontFamily: ThemeProperties.primaryFont,
      fontSize: "14px",
      fontWeight: "bold",
    },
    specificTabBold: {
      fontFamily: ThemeProperties.primaryFont,
      fontSize: "16px",
      fontWeight: "bold",
    },
    tableHead: {
      fontWeight: 600,
      fontFamily: ThemeProperties.primaryFont,
      fontSize: "1.4rem",
      "@media (max-width:1350px)": {
        fontSize: "1.2rem",
      },
      "@media (max-width:900px)": {
        fontSize: "1.1rem",
      },
      color: ThemeProperties.mainTextColor,
    },
    paperHeader: {
      fontFamily: ThemeProperties.primaryFont,
      fontSize: 15,
      fontWeight: 600,
      color: ThemeProperties.mainTextColor,
    },
    paperHeaderWhite: {
      fontFamily: ThemeProperties.primaryFont,
      fontSize: 15,
      fontWeight: 400,
      color: ThemeProperties.white,
    },

    bigNumberPurple: {
      fontFamily: ThemeProperties.primaryFont,
      fontSize: "4.8rem",
      fontWeight: 300,
      color: ThemeProperties.purple,
    },

    mediumNumberPurple: {
      fontFamily: ThemeProperties.primaryFont,
      fontSize: "2.4rem",
      fontWeight: 400,
      color: ThemeProperties.purple,
    },

    mediumNumberBlack: {
      fontFamily: ThemeProperties.primaryFont,
      fontSize: "2.4rem",
      fontWeight: 400,
      color: ThemeProperties.black,
    },

    textDownloadCSV: {
      fontSize: 11,
      fontWeight: 500,
      fontFamily: "Roboto",
    },
    textSubtitle: {
      fontFamily: ThemeProperties.primaryFont,
      fontSize: "1.4rem",
      "@media (max-width:1350px)": {
        fontSize: "1.3rem",
      },
      "@media (max-width:900px)": {
        fontSize: "1.2rem",
      },
      fontWeight: 400,
      color: ThemeProperties.mainTextColor,
    },
    textPasswordReset: {
      fontFamily: ThemeProperties.primaryFont,
      fontSize: "1.4rem",
      "@media (max-width:1350px)": {
        fontSize: "1.3rem",
      },
      "@media (max-width:900px)": {
        fontSize: "1.2rem",
      },
      fontWeight: 300,
      color: "#444",
      p: "1rem",
      margin: "1rem",
    },

    textDisabled: {
      fontFamily: ThemeProperties.primaryFont,
      fontSize: "1.4rem",
      fontWeight: 400,
      color: "rgba(0,0,0,0.40)",
    },
    textBoldSubtitle: {
      fontFamily: ThemeProperties.primaryFont,
      fontSize: "1.4rem",
      "@media (max-width:1350px)": {
        fontSize: "1.3rem",
      },
      "@media (max-width:900px)": {
        fontSize: "1.2rem",
      },
      fontWeight: 500,
      color: ThemeProperties.black,
    },
    textBoldSubtitleMd: {
      fontFamily: ThemeProperties.primaryFont,
      fontSize: "1.2rem",
      fontWeight: 500,
      color: ThemeProperties.mainTextColor,
    },
    textBoldSubtitleLg: {
      fontFamily: ThemeProperties.primaryFont,
      fontSize: "1.4rem",
      fontWeight: 500,
      color: ThemeProperties.mainTextColor,
    },
    textBoldSubtitleXl: {
      fontFamily: ThemeProperties.primaryFont,
      fontSize: "1.4rem",
      fontWeight: 500,
      color: ThemeProperties.mainTextColor,
    },
    textSubtitlePurple: {
      fontFamily: ThemeProperties.primaryFont,
      fontSize: "1.4rem",
      fontWeight: 400,
      color: ThemeProperties.purple,
    },
    textSubtitleWhite: {
      fontFamily: ThemeProperties.primaryFont,
      fontSize: "1.4rem",
      fontWeight: 400,
      color: ThemeProperties.white,
    },
    textSubtitleRed: {
      fontFamily: ThemeProperties.primaryFont,
      fontSize: "1.4rem",
      fontWeight: 400,
      color: ThemeProperties.red_400,
    },
    textSubtitleGrey: {
      fontFamily: ThemeProperties.primaryFont,
      fontSize: "1.4rem",
      fontWeight: 400,
      color: ThemeProperties.greyTextColor,
    },
    textSubtitleSmall: {
      fontFamily: ThemeProperties.primaryFont,
      fontSize: "1.3rem",
      fontWeight: 400,
      color: ThemeProperties.mainTextColor,
    },
    textSubtitleBold: {
      fontFamily: ThemeProperties.primaryFont,
      fontSize: 20,
      fontWeight: 600,
      color: ThemeProperties.mainTextColor,
    },
    textSubtitleBoldRed: {
      fontFamily: ThemeProperties.primaryFont,
      fontSize: "1.6rem",
      fontWeight: 500,
      color: ThemeProperties.red_400,
    },
    textSubtitleBoldPurple: {
      fontFamily: ThemeProperties.primaryFont,
      fontSize: "1.6rem",
      fontWeight: 500,
      color: ThemeProperties.purple,
    },
    textDescription: {
      fontFamily: ThemeProperties.primaryFont,
      fontSize: "1.2rem",
      "@media (max-width:1350px)": {
        fontSize: "1.1rem",
      },
      "@media (max-width:900px)": {
        fontSize: "1rem",
      },
      fontWeight: 500,
      color: ThemeProperties.greyTextColor,
    },
    textDescriptionActive: {
      fontFamily: ThemeProperties.primaryFont,
      fontSize: "1.3rem",
      fontWeight: 500,
      color: ThemeProperties.black,
    },
    textDescriptionActivePurple: {
      fontFamily: ThemeProperties.primaryFont,
      fontSize: "1.2rem",
      fontWeight: 500,
      color: ThemeProperties.purple,
    },
    textDescriptionActiveWhite: {
      fontFamily: ThemeProperties.primaryFont,
      fontSize: "1.2rem",
      fontWeight: 500,
      color: ThemeProperties.white,
    },
    textDescriptionActiveBlack: {
      fontFamily: ThemeProperties.primaryFont,
      fontSize: "1.2rem",
      fontWeight: 500,
      color: ThemeProperties.black,
    }
  },
});

export default theme;
